export const email = "toskinga01@gmail.com";
export const facebook = "https://www.facebook.com/kinga.tos/";
export const github = "https://github.com/kingatos";
export const linkedin = "https://www.linkedin.com/in/kinga-tos/";
export const instagram = "https://www.instagram.com/pantherkika/";

export const personalInfo = [
  {
    title: "My skillset includes",
    icon: "🛠️",
    list: [
      "JavaScript ES6+",
      "React",
      "Redux-Saga",
      "Redux (Toolkit)",
      "React Hooks",
      "React Router",
      "Semantic & accessible HTML",
      "Responsive Web Design",
      "CSS BEM convention",
      "CSS Grid",
      "CSS Flexbox",
      "Working with API (axios, fetch)",
      "Teamwork",
      "Markdown",
      "Immutability",
      "Error handling",
      "Promises, Async/Await",
      "GitHub Pull Requests & Review",
      "Trello",
      "Scrum",
      "NPM",
      "Git",
    ],
  },
  {
    title: "What I want to learn next",
    icon: "🚀",
    list: [
      "Typescript",
      "Node.js",
      "Unit testing",
      "React Context",
      "Cypress",
      "JS classes",
    ],
  },
];
